module.exports = __webpack_public_path__ + "static/img/bg49.d930b8b7.png";